import { stock } from '@/data/stockImages';
import * as otomasyon from './posts/kafe-restoran-otomasyon-sistemi-nedir';
import * as qrMenuNedir from './posts/qr-menu-nedir';
import * as qrMenuOlustur from './posts/qr-menu-nasil-olusturulur';
import * as masadanSiparis from './posts/qr-kod-ile-masadan-siparis';
import * as siparisSistemi from './posts/kafe-siparis-sistemi-nedir';
import * as stokTakibi from './posts/stok-takibi-nasil-yapilir';
import * as urunMaliyeti from './posts/urun-maliyeti-nasil-hesaplanir';
import * as menuFiyatlari from './posts/kafe-menu-fiyatlari-nasil-belirlenir';
import * as musteriSadakati from './posts/kafe-musteri-sadakati-nasil-artirilir';
import * as sadakatKarti from './posts/dijital-sadakat-karti-ve-puan-sistemi';
import * as programSecimi from './posts/kafe-restoran-yonetim-programi-secimi';
import * as krokiSistemi from './posts/restoran-kroki-sistemi';
import * as teknolojiSirketleri from './posts/turkiyede-restoran-teknoloji-sirketleri';

/* =====================================================================
   Blog kaydı → /blog ve /blog/:slug
   İçerik: ./posts/<slug>.js (varsayılan export = blok dizisi, `faq` = yazı sonu SSS).
   Dosya adı = slug. Prerender listesi, sitemap.xml ve llms.txt build sırasında
   otomatik üretilir (scripts/prerender.cjs, scripts/seo-files.cjs) — elle ekleme yok.
   Yeni yazı eklerken: dosyayı oluştur, buraya import + kayıt, `related` 2–3 komşu.
   Sıra: /blog listesi ve ana sayfa bu sırayı kullanır (ilk 3 ana sayfada).
   Yazım kuralları: .claude/skills/landing-copy/SKILL.md
   ===================================================================== */

const content = (mod) => ({ blocks: mod.default, faq: mod.faq });

const POSTS = [
  {
    slug: 'kafe-restoran-otomasyon-sistemi-nedir',
    keywords: [
      'kafe otomasyon sistemi',
      'restoran otomasyon sistemi',
      'restoran otomasyon programı',
      'adisyon programı',
      'restoran yönetim sistemi',
    ],
    title: 'Kafe ve Restoran Otomasyon Sistemi Nedir? Ne İşe Yarar?',
    metaTitle: 'Kafe ve Restoran Otomasyon Sistemi Nedir? Modüller ve Seçim',
    description:
      'Kafe ve restoran otomasyon sistemi nedir, hangi modüllerden oluşur? Kafe ile restoranda ihtiyaç farkı, adisyon ve yazarkasa karşılaştırması, seçim kriterleri.',
    excerpt:
      'Sipariş, masa, hesap, stok ve raporları tek yazılımda toplayan sistemin parçaları ve seçerken bakılacaklar.',
    date: '2026-09-27',
    cover: stock('garson-tablet', 'Elinde tabletle sipariş alan garson'),
    ...content(otomasyon),
    related: ['kafe-restoran-yonetim-programi-secimi', 'kafe-siparis-sistemi-nedir', 'qr-menu-nedir'],
  },
  {
    slug: 'qr-menu-nasil-olusturulur',
    keywords: [
      'qr menü oluşturma',
      'qr menü hazırlama',
      'ücretsiz qr menü',
      'kafe qr menü',
      'restoran qr menü',
      'dijital menü',
    ],
    title: 'QR Menü Nasıl Oluşturulur? Adım Adım Rehber',
    metaTitle: 'QR Menü Nasıl Oluşturulur? Kafe ve Restoran İçin Adım Adım',
    description:
      'QR menü oluşturmanın iki yolu, hazırlık listesi ve adım adım kurulum. Kafe ve restoran menüsü için ipuçları, sık yapılan hatalar ve fiyat listesi düzenlemesi.',
    excerpt:
      'PDF menü ile yazılımla hazırlanan menünün farkı, hazırlık listesi ve kafe ile restoran için adım adım kurulum.',
    date: '2026-09-27',
    cover: stock('masa-qr-standi', 'Kafe masasında QR kodlu menü standı'),
    ...content(qrMenuOlustur),
    related: ['qr-menu-nedir', 'qr-kod-ile-masadan-siparis', 'kafe-menu-fiyatlari-nasil-belirlenir'],
  },
  {
    slug: 'urun-maliyeti-nasil-hesaplanir',
    keywords: [
      'ürün maliyeti hesaplama',
      'yemek maliyeti hesaplama',
      'food cost',
      'reçete maliyeti',
      'restoran maliyet hesabı',
    ],
    title: 'Ürün ve Yemek Maliyeti Nasıl Hesaplanır? Kafe ve Restoranlar İçin',
    metaTitle: 'Ürün ve Yemek Maliyeti Nasıl Hesaplanır? Örnekli Hesap',
    description:
      'Kafede ürün, restoranda yemek maliyeti nasıl hesaplanır? Latte ve ızgara somon örnekleriyle reçete maliyeti, fire payı, food cost oranı ve güncel alış fiyatı.',
    excerpt: 'Latte ve ızgara somon örnekleriyle reçete maliyeti, kullanılabilir oran ve maliyet oranı hesabı.',
    date: '2026-09-27',
    cover: stock('izgara-somon', 'Sebzeli ızgara somon tabağı'),
    ...content(urunMaliyeti),
    related: [
      'kafe-menu-fiyatlari-nasil-belirlenir',
      'stok-takibi-nasil-yapilir',
      'dijital-sadakat-karti-ve-puan-sistemi',
    ],
  },
  {
    slug: 'qr-menu-nedir',
    keywords: ['qr menü', 'qr menü nedir', 'dijital menü', 'karekod menü', 'qr kod menü', 'restoran qr menü'],
    title: 'QR Menü Nedir? Kafeler ve Restoranlar İçin Nasıl Çalışır?',
    metaTitle: 'QR Menü Nedir, Nasıl Çalışır? Kafe ve Restoranlar İçin',
    description:
      'QR menü nedir, nasıl çalışır? Basılı menüden farkı, menüde yer alan bilgiler, siparişli ve görüntüleme amaçlı QR menü, kafe ve restoranda kullanım.',
    excerpt: 'Masadaki kodun nasıl çalıştığı, basılı menüye göre farkı ve siparişli QR menünün ne zaman uygun olduğu.',
    date: '2026-09-27',
    cover: stock('qr-menu-el', 'Elde tutulan telefonda açık QR menü'),
    ...content(qrMenuNedir),
    related: ['qr-menu-nasil-olusturulur', 'qr-kod-ile-masadan-siparis', 'kafe-restoran-otomasyon-sistemi-nedir'],
  },
  {
    slug: 'qr-kod-ile-masadan-siparis',
    keywords: ['qr kod ile sipariş', 'masadan sipariş sistemi', 'qr menü sipariş', 'dijital menü sipariş'],
    title: 'QR Kod ile Masadan Sipariş Alma Sistemi Nasıl Çalışır?',
    metaTitle: 'QR Kod ile Masadan Sipariş: Nasıl Çalışır, Nasıl Kurulur?',
    description:
      'QR kod ile masadan siparişte müşteri ve personel tarafındaki akış, sipariş onayı, masa başına QR kod, bildirimler ve kurulumda verilecek kararlar.',
    excerpt: 'Müşterinin menüden verdiği siparişin onaydan masaya kadar izlediği yol ve kurulumda verilecek kararlar.',
    date: '2026-09-27',
    cover: stock('teras-aksam', 'Gün batımında deniz manzaralı restoran terası'),
    ...content(masadanSiparis),
    related: ['qr-menu-nedir', 'kafe-siparis-sistemi-nedir', 'qr-menu-nasil-olusturulur'],
  },
  {
    slug: 'kafe-siparis-sistemi-nedir',
    keywords: ['kafe sipariş sistemi', 'restoran sipariş sistemi', 'adisyon sistemi', 'garson sipariş programı'],
    title: 'Kafe Sipariş Sistemi Nedir? Nasıl Çalışır?',
    metaTitle: 'Kafe Sipariş Sistemi Nedir? Garson, QR Menü ve Kasa',
    description:
      'Kafe sipariş sistemi nedir, nasıl çalışır? Sipariş girişi, mutfak ve bara yönlendirme, durum takibi, hesap kapatma, sipariş kanalları ve seçerken bakılacaklar.',
    excerpt: 'Siparişin girişinden hesabın kapanmasına kadar sistemin parçaları ve garson, QR menü, kasa kanalları.',
    date: '2026-09-27',
    cover: stock('garson-siparis', 'Masada tabletle sipariş alan garson'),
    ...content(siparisSistemi),
    related: [
      'qr-kod-ile-masadan-siparis',
      'kafe-restoran-otomasyon-sistemi-nedir',
      'kafe-restoran-yonetim-programi-secimi',
    ],
  },
  {
    slug: 'stok-takibi-nasil-yapilir',
    keywords: [
      'restoran stok takibi',
      'kafe stok takibi',
      'stok takip programı',
      'reçeteli stok takibi',
      'fire takibi',
    ],
    title: 'Kafe ve Restoranlarda Stok Takibi Nasıl Yapılır?',
    metaTitle: 'Restoran Stok Takibi Nasıl Yapılır? Kafe ve Restoranlar İçin',
    description:
      'Restoran ve kafe stok takibi nasıl yapılır? Stoğun neden tutmadığı, reçeteli stok düşümü, giriş ve sayım, sayım farkının yorumu ve fireyi azaltma yolları.',
    excerpt: 'Stoğun neden tutmadığı, reçeteli takibin nasıl kurulacağı ve sayım farkının nasıl yorumlanacağı.',
    date: '2026-09-27',
    cover: stock('sef', 'Mutfakta tabağı hazırlayan şef'),
    ...content(stokTakibi),
    related: ['urun-maliyeti-nasil-hesaplanir', 'kafe-menu-fiyatlari-nasil-belirlenir', 'kafe-siparis-sistemi-nedir'],
  },
  {
    slug: 'kafe-menu-fiyatlari-nasil-belirlenir',
    keywords: ['kafe menü fiyatları', 'menü fiyatlandırma', 'restoran fiyat hesaplama', 'menü mühendisliği'],
    title: 'Kafe Menü Fiyatları Nasıl Belirlenir?',
    metaTitle: 'Kafe Menü Fiyatları Nasıl Belirlenir? Hesap ve Örnekler',
    description:
      'Kafe menü fiyatları nasıl belirlenir? Maliyet oranına göre fiyat hesabı, KDV, sabit gider ve katkı payı, menü mühendisliği ve fiyat güncelleme zamanı.',
    excerpt: 'Maliyet oranından menü fiyatına, sabit giderlerden menü mühendisliğine örneklerle fiyatlandırma.',
    date: '2026-09-27',
    cover: stock('latte', 'Latte art ile servis edilen kahve'),
    ...content(menuFiyatlari),
    related: ['urun-maliyeti-nasil-hesaplanir', 'stok-takibi-nasil-yapilir', 'qr-menu-nasil-olusturulur'],
  },
  {
    slug: 'kafe-musteri-sadakati-nasil-artirilir',
    keywords: ['müşteri sadakati', 'kafe müşteri sadakati', 'sadakat programı', 'kampanya yönetimi'],
    title: 'Kafe Müşteri Sadakati Nasıl Artırılır?',
    metaTitle: 'Kafe Müşteri Sadakati Nasıl Artırılır? Nedenler ve Adımlar',
    description:
      'Kafede müşteri sadakati nasıl artırılır? Müşterinin neden geri gelmediği, sadakatin ölçülmesi, ürün standardı, bekleme süresi, sadakat programı ve kampanyalar.',
    excerpt: 'Müşterinin neden geri gelmediği, sadakatin nasıl ölçüleceği ve tekrar gelişi artıran adımlar.',
    date: '2026-09-27',
    cover: stock('musteri-qr', 'Masada telefonundan menüye bakıp gülümseyen müşteri'),
    ...content(musteriSadakati),
    related: ['dijital-sadakat-karti-ve-puan-sistemi', 'qr-kod-ile-masadan-siparis', 'stok-takibi-nasil-yapilir'],
  },
  {
    slug: 'dijital-sadakat-karti-ve-puan-sistemi',
    keywords: ['dijital sadakat kartı', 'puan sistemi', 'kafe sadakat kartı', 'sadakat uygulaması'],
    title: 'Dijital Sadakat Kartı Nedir? Kafelerde Puan Sistemi Nasıl Çalışır?',
    metaTitle: 'Dijital Sadakat Kartı ve Kafelerde Puan Sistemi',
    description:
      'Dijital sadakat kartı nedir, kafelerde puan sistemi nasıl çalışır? Kafe kartı, ziyaret sayısı, klasik puan, anlık kampanyalar ve bir ödülün gerçek maliyeti.',
    excerpt: 'Karton karttan dijital karta, puan ve ödül sistemleri ve bir ödülün işletmeye gerçekte neye mal olduğu.',
    date: '2026-09-27',
    cover: stock('sadakat-programi', 'Sadakat kartı ve telefonda 250 puanlık sadakat programı ekranı'),
    ...content(sadakatKarti),
    related: [
      'kafe-musteri-sadakati-nasil-artirilir',
      'urun-maliyeti-nasil-hesaplanir',
      'kafe-restoran-otomasyon-sistemi-nedir',
    ],
  },
  {
    slug: 'kafe-restoran-yonetim-programi-secimi',
    keywords: [
      'restoran yönetim programı',
      'kafe yönetim sistemi',
      'restoran programı seçimi',
      'adisyon programı seçimi',
    ],
    title: 'Kafe ve Restoran Yönetim Programı Seçerken Nelere Dikkat Edilmeli?',
    metaTitle: 'Kafe ve Restoran Yönetim Programı Seçerken Nelere Dikkat Edilmeli?',
    description:
      'Kafe ve restoran yönetim programı seçerken bakılacaklar: kontrol listesi, bulut ve yerel kurulum farkı, fiyatlandırma modeli, veriler ve KVKK, destek ve deneme.',
    excerpt:
      'Sağlayıcılara sorulacak sorular, fiyatlandırma modelinin doğru okunması ve deneme sırasında bakılacaklar.',
    date: '2026-09-27',
    cover: stock('panel-tablet', 'Tablette satış grafiği ve siparişleri gösteren yönetim paneli'),
    ...content(programSecimi),
    related: ['kafe-restoran-otomasyon-sistemi-nedir', 'kafe-siparis-sistemi-nedir', 'urun-maliyeti-nasil-hesaplanir'],
  },
  {
    slug: 'restoran-kroki-sistemi',
    keywords: [
      'restoran kroki sistemi',
      'restoran krokisi',
      'masa planı',
      'masa takip programı',
      'restoran masa yönetimi',
    ],
    title: 'Restoran Kroki Sistemi Nedir? Masa Planı ile Masa Takibi',
    metaTitle: 'Restoran Kroki Sistemi Nedir? Kroki mi, Gruplu Masa Listesi mi?',
    description:
      'Restoran kroki sistemi nedir, ne işe yarar? Görsel masa krokisi ile bölgelere göre gruplu masa listesinin farkı, hangi işletmeye uygun olduğu ve masa düzeni ipuçları.',
    excerpt: 'Masa krokisinin ne işe yaradığı, gruplu masa listesiyle farkı ve masa düzenini planlarken bakılacaklar.',
    date: '2026-09-28',
    cover: stock('kafe-ic-mekan', 'Ahşap masalı, sıcak ışıklı restoran salonu'),
    ...content(krokiSistemi),
    related: ['kafe-siparis-sistemi-nedir', 'qr-kod-ile-masadan-siparis', 'kafe-restoran-otomasyon-sistemi-nedir'],
  },
  {
    slug: 'turkiyede-restoran-teknoloji-sirketleri',
    keywords: [
      'türkiye restoran teknoloji şirketleri',
      'restoran teknolojisi',
      'restoran yazılım şirketleri',
      'yerli restoran yazılımı',
      'restoran otomasyon firmaları',
    ],
    title: 'Türkiye’de Restoran Teknoloji Şirketleri: Hangi Çözümlere İhtiyacınız Var?',
    metaTitle: 'Türkiye’de Restoran Teknoloji Şirketleri ve Çözümleri',
    description:
      'Türkiye’de restoran teknoloji şirketleri hangi alanlarda çözüm sunar? Adisyon, ÖKC/POS, QR menü, online sipariş, stok ve sadakat; yerli sağlayıcıda nelere bakılır.',
    excerpt:
      'Restoran teknolojisinin parçaları, yerli bir sağlayıcıda bakılacaklar ve birden fazla çözümü birlikte kullanmak.',
    date: '2026-09-28',
    cover: stock('cihazlar', 'Dizüstü bilgisayar, tablet ve telefonda açık restoran yönetim paneli'),
    ...content(teknolojiSirketleri),
    related: [
      'kafe-restoran-yonetim-programi-secimi',
      'kafe-restoran-otomasyon-sistemi-nedir',
      'stok-takibi-nasil-yapilir',
    ],
  },
];

// Blok metinlerinden kaba kelime sayısı → dakika (≈200 kelime/dk).
const blockText = (b) =>
  [
    b.text,
    b.title,
    ...(b.items || []).map((i) => (typeof i === 'string' ? i : `${i.title} ${i.text}`)),
    ...(b.rows || []).flat(),
  ]
    .filter(Boolean)
    .join(' ');
const readMinutes = (blocks) => Math.max(1, Math.round(blocks.map(blockText).join(' ').split(/\s+/).length / 200));

export const BLOG_POSTS = POSTS.map((p) => ({ ...p, readMinutes: readMinutes(p.blocks) }));
export const getPost = (slug) => BLOG_POSTS.find((p) => p.slug === slug);

export const formatDate = (iso) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });
